
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder,FormControl,FormGroup,Validators,} from "@angular/forms";
import { ItemModifierService } from "../ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../shared/store/userInfo.store";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';




@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})

export class OrdersComponent implements OnInit {

  CK_COUPON: boolean = false;

  CK: boolean = false;
  alertmsg1: string = null;
  showalert1: boolean = false;

  alertmsg: string = null;showalert: boolean = false;
  newproductData: any;
  IDSS :number =0;

  ids :number =0;
  SID :number =0;
  closeResult: string;

  IVN: string;
  Notes: string;
  TrackInfo: any;
  //moveForm: FormGroup;
  moveModalReference: any;

  loggedIn = false;
  cartItems11 = [];cartItems222 = [];
  cartItems1 = [];  cartItems2 = [];
  cartItems3 = [];

  cartItemsyourorders = [];
  cartItemsorderdetails = [];

  cartItemsorderdetailsMaster = [];

  cartItemsorderdetailscancel = [];

  constructor
  (
    private infoStore: UserInfoStore,
    private router: Router,
    private itemModifierService: ItemModifierService,
    private modalService: NgbModal

  ) { }

  getCartItems; getCartItemsOrdered;  getCartItemsOrderedCancelled;
  total: number = 0;
  total1: number = 0; total2: number = 0;
  cancelForm: FormGroup;

  ngOnInit() {

    this.CK_COUPON=false;

    this.cancelForm = new FormGroup({
      SetDefault: new FormControl(),
      OtherDetails: new FormControl(),

    });

    this.getNewProductList();
    this.FillOrder();


    if( sessionStorage.getItem("ProceedPay_Id")=="1" ){

      this.infoStore.setCartInfo([]);
      sessionStorage.clear();
      this.infoStore.setInfo({});

     alert("Session Expired , Please Login  !!");
       //this.router.navigateByUrl("login");

     }


  }

  getNewProductList() {
    this.newproductData = [
      { ViewStateNewProduct: "You dont like the product" },
      { ViewStateNewProduct: "You changed your mind" },
      { ViewStateNewProduct: "You want to buy another product" },
      { ViewStateNewProduct: "Others" },
      // { ViewStateNewProduct: "You changed your mind" },

    ];
  }

  
  onOptionsSelectedClassification(value){
    //this.itemcategoryData 
     console.log(value);

     if(  value=="Others")
     {
        this.CK=true;
     }
     else
     {
         this.CK=false;

     }
    
    
  }

  FillOrder(){

    if (sessionStorage.getItem("OrderMaster_Id")) {

      this.ids=0;
      this.loggedIn = true;
      this.total1 = 0;
      this.itemModifierService
        .getCartItemsOrdered( Number(sessionStorage.getItem("LoggedInId")) )
        .subscribe((event: any) => {
          if (event.length > 0) {

            this.cartItemsyourorders = event;


          } else {
            this.cartItemsyourorders = [];
          }
        });
    } else {
      this.loggedIn = false;
      this.cartItemsyourorders = [];

    }


    if (sessionStorage.getItem("OrderMaster_Id")) {

      this.ids=0;
      this.loggedIn = true;
      this.total1 = 0;
      this.itemModifierService
        .getCartItemsOrderedCancelled( Number(sessionStorage.getItem("LoggedInId")) )
        .subscribe((event: any) => {
          if (event.length > 0) {

            this.cartItemsorderdetailscancel = event;

            //  var str = datas[0].OperationStatus;
         


          } else {
            this.cartItemsorderdetailscancel = [];
          }
        });
    } else {
      this.loggedIn = false;
      this.cartItemsorderdetailscancel = [];

    }


  }

  loginredirect() {
    this.router.navigateByUrl("login");
  }
  homeRedirect() {
    this.router.navigateByUrl("home");
  }
  checkout() {
    this.router.navigateByUrl("checkout");
  }



  openMoveModal1(content) {
    //this.moveForm.reset();
    this.moveModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.moveModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });


  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
     return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
     return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
   }
  }

  openMoveModal2(content) {

    this.CK=false;
    this.cancelForm.reset();
    this.moveModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.moveModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });


  }

  openMoveModal3(content) {
    this.cancelForm.reset();
    this.moveModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.moveModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });


  }

  openMoveModal4(content) {
    this.cancelForm.reset();
    this.moveModalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.moveModalReference.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });


  }

  detOrder( iddss){

    this.IVN=iddss;

    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.loggedIn = true;
      //this.total2 = 0;
      this.itemModifierService
        .getAllOrderItemByInvoiceNO(iddss)
        .subscribe((event: any) => {
          if (event.length > 0) {

            this.cartItemsorderdetails = event;

          } else {

            this.cartItemsorderdetails = [];
            //this.total2 = 0;

          }
        });
    } else {

      this.loggedIn = false;
      this.cartItemsorderdetails = [];
      //this.total2 = 0;

    }

    
    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.loggedIn = true;
      //this.total2 = 0;
      this.itemModifierService
        .GetAllBillByInvoiceNOStockOut(iddss)
        .subscribe((event: any) => {
          if (event.length > 0) {

            this.cartItemsorderdetailsMaster = event;

            if(   event[0].CouponCode == null   ||   event[0].CouponCode == ''  ){

              this.CK_COUPON=false;

            }else{

              this.CK_COUPON=true;
            }



          } else {

            this.cartItemsorderdetailsMaster = [];
            //this.total2 = 0;

          }
        });
    } else {

      this.loggedIn = false;
      this.cartItemsorderdetailsMaster = [];
      //this.total2 = 0;

    }



  }

  trackOrder( Ids){


    this.alertmsg ="";
    this.alertmsg1 = "Please  wait for a moment .... !!";
    this.showalert1 = true;

      //this.TrackInfo="";
     // this.ids=Ids;
      this.itemModifierService
        .getAllOrderItemByInvoiceNO(Ids)
        .subscribe((event: any) => {
          if (event.length > 0) {

            this.IVN = event[0].InvoiceNO;
            this.itemModifierService.getAllTrackByOrderId(this.IVN).subscribe((data: any) => {

             
              //this.TrackInfo="";
              this.cartItems3=data;
              //this.TrackInfo=data[200];
              this.TrackInfo=this.cartItems3;
              this.alertmsg = this.TrackInfo;
              //  this.showalert = true;

              this.showalert1 = true;
              setTimeout(() => {
                this.showalert1 = false;
              }, 2000);

                          
                  //////////////////// 1
                  var newWindow = window.open(
                    "https://trackyourorder.hideandskin.in/MyOrder.aspx?BillNO="+this.IVN,
                    "_blank",
                    "location=yes,height=570,width=800,scrollbars=yes,status=yes"
                  );


                 

            });


          } else {

            this.alertmsg = "";
            this.showalert1 = true;
            setTimeout(() => {
              this.showalert1 = false;
            }, 2000);

          }
        });

  }

  cancelOrder( Ids){

    this.IVN=Ids;

  }

  cancelSubmit(){

    this.Notes=  this.cancelForm.value.SetDefault +"-----"+  this.cancelForm.value.OtherDetails ;

    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.loggedIn = true;
      //this.total2 = 0;
      this.itemModifierService
        .getcancelOrderItem(this.IVN,this.Notes)
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.FillOrder();


          } else {

            this.FillOrder();

          }
        });
    } else {



    }


    //this.companyModalReference.close();



    this.moveModalReference.close();

  }


  

}
